// The invite token otherwise lives only in the URL, and every logout lands on a bare
// /login — so a trainee who signed in with the wrong account, logged out and came back
// with the right one reached onboarding with no invite (#199).
//
// sessionStorage, not localStorage: it has to survive a logout, not the tab. Store iPads
// are shared, and the next person must not inherit the previous person's invite.
// Storage access throws when site data is blocked; then this is the old URL-only behaviour.
const KEY = 'ace:invite-token';

export const rememberInviteToken = (token) => {
  try {
    if (token) sessionStorage.setItem(KEY, token);
  } catch {
    // storage blocked
  }
};

export const rememberedInviteToken = () => {
  try {
    return sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
};
